export default "__VITE_ASSET__v4QMEbL0__"